import React from "react";
import BaseDivideLine from "../../../../components/BaseDivideLine";
import BaseTextButton from "../../../../components/BaseTextButton";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import ROUTES from "../../../../utils/routes";
import getDomainPrice from "../../../../utils/getDomainPrice";

export default function CreateNewGame({ createNewGame }) {
  CreateNewGame.propTypes = {
    createNewGame: PropTypes.func,
  };
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <>
      <BaseDivideLine dash={true} top={true} />
      <div className="create-game">
        <BaseTextButton
          icon="plus"
          onClick={() =>
            navigate(ROUTES.PAYMENT_PAGE, {
              state: { from: location.pathname },
            })
          }
        >
          {t("personal_acc.buy_intouch", { price: getDomainPrice() })}
        </BaseTextButton>
        <BaseTextButton icon="plus" onClick={createNewGame}>
          {t("personal_acc.go_test")}
        </BaseTextButton>
      </div>
    </>
  );
}
